import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ProhibitedItemsRoutingModule } from "./prohibited-items-routing.module";
import { ProhibitedItemsComponent } from "./prohibited-items.component";
@NgModule({
    declarations: [
        ProhibitedItemsComponent
    ],
    imports: [
        CommonModule,
        ProhibitedItemsRoutingModule,
        FormsModule,
    ]
})
export  class ProhibitedItemsModule {}